/* Retry one transient CDN failure without changing image selection or quality. */
(() => {
  const retried = new WeakSet();
  const selector = '.od-gallery img, .od-detail img, #d1m-home-v2 img';
  const isShopify = value => {
    try {
      const url = new URL(value, document.baseURI);
      return url.hostname === 'cdn.shopify.com' ||
        (url.origin === location.origin && /^\/cdn\/shop\/(?:files|t)\//.test(url.pathname));
    } catch { return false; }
  };
  const recover = image => {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector) ||
        retried.has(image) || !isShopify(image.currentSrc || image.src)) return;
    retried.add(image);
    setTimeout(() => {
      if (!image.isConnected || (image.complete && image.naturalWidth > 0)) return;
      // Reassign the unchanged selection inputs. Do not replace currentSrc with
      // a fallback URL: srcset/picture must retain responsive art direction.
      const srcset = image.getAttribute('srcset');
      const src = image.getAttribute('src');
      if (srcset !== null) image.setAttribute('srcset', srcset);
      if (src !== null) image.setAttribute('src', src);
    }, 250);
  };
  document.addEventListener('error', event => recover(event.target), true);
  const inspect = () => document.querySelectorAll(selector).forEach(image => {
    if (image.complete && image.naturalWidth === 0 && (image.currentSrc || image.getAttribute('src') || image.getAttribute('srcset'))) recover(image);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inspect, { once: true });
  else inspect();
})();
